import React from 'react'
import {
  CustomPointsPackage,
  PointsPackage,
  PurchaseOptions,
  SingleCardPackage,
} from '../components'
import { useAccount } from 'src/hooks'

interface PointsPackagesProps {
  pointOption: number
  setPointOption: (option: number) => void
  setPointAmount: (amount: number) => void
  setPricePerPoint: (price: number) => void
}

const PointsPackagesContainer: React.FC<PointsPackagesProps> = props => {
  const {
    pointOption,
    setPointOption,
    setPointAmount,
    setPricePerPoint,
  } = props

  const account = useAccount()

  const handleSelect = (
    option: number,
    pricePerPoint: number,
    amount: number,
  ): void => {
    option === pointOption ? setPointOption(0) : setPointOption(option)
    setPricePerPoint(pricePerPoint)
    setPointAmount(amount)
  }

  return (
    <PurchaseOptions
      title="Points Packages"
      subtitle="Points pay for cards and gifts."
      kind="points"
      amount={account.points.amount}
    >
      <SingleCardPackage
        key="points-package-1"
        onSelect={handleSelect}
        isSelected={pointOption === 1}
        option={1}
      />
      <PointsPackage
        key="points-package-2"
        points={100}
        onSelect={handleSelect}
        isSelected={pointOption === 2}
        option={2}
      />
      <PointsPackage
        key="points-package-3"
        points={200}
        onSelect={handleSelect}
        isSelected={pointOption === 3}
        option={3}
      />
      <PointsPackage
        key="points-package-4"
        points={350}
        onSelect={handleSelect}
        isSelected={pointOption === 4}
        option={4}
      />
      <CustomPointsPackage
        key="points-package-5"
        onSelect={handleSelect}
        isSelected={pointOption === 5}
        option={5}
        setPointAmount={setPointAmount}
        setPricePerPoint={setPricePerPoint}
      />
    </PurchaseOptions>
  )
}

export default PointsPackagesContainer
